var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-loader",class:_vm.appLoading ? 'visible' : 'hidden'},[_c('div',{staticClass:"loader"},[_vm._v(" loading app... ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }